import { Grid } from '@mui/material';

import {
	BooleanDescField,
	CurrencyTextField,
	// DateField,
	// NumberTextField,
	SearchSelectField,
	SimpleTextField,
	TagsSelectField,
	useSettings
} from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function CompaniesDetailsSectionSecondaryInfo(props: DetailsSectionInfoContentProps) {
	const { sysSettings, t } = useSettings();

	const isErpLinked = !!(props.model.comp_erp_customer_id || props.model.comp_erp_supplier_id);

	return (
		<>
			{/* TAGS */}
			<Grid size={12}>
				<TagsSelectField
					name="comp_tags"
					label={t('DETAILS_COMPANIES_FIELD_TAGS')}
					value={props.model.comp_tags}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* WARNING */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="comp_warning_desc"
					label={t('DETAILS_COMPANIES_FIELD_WARNING')}
					value={props.model.comp_warning_desc}
					icon="alert-outline"
					color="warning.main"
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* BLOCKED */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<BooleanDescField
					name="comp_blocked_desc"
					label={t('DETAILS_COMPANIES_FIELD_BLOCKED')}
					value={props.model.comp_blocked_desc}
					icon="cancel"
					color="error.main"
					isEdit={props.isEdit && !props.model.comp_erp_customer_id && !props.model.comp_erp_supplier_id}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* CERTIFIED MAIL */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="comp_pec"
					label={t('DETAILS_COMPANIES_FIELD_PEC')}
					value={props.model.comp_pec}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
					validations={{ isEmail: true }}
					validationErrors={{ isEmail: t('ERROR_TEXT_EMAIL') }}
				/>
			</Grid>
			{/* LEGAL FORM */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_cole_id"
					label={t('DETAILS_COMPANIES_FIELD_LEGAL_FORM')}
					systable="companies_legalforms"
					value={props.model.comp_cole_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* ATECO CODE */}
			{/* <Grid size={12}>
				<SearchSelectField
					name="comp_ateco_id"
					label={t('DETAILS_COMPANIES_FIELD_ATECO')}
					systable="companies_ateco"
					value={props.model.comp_ateco_id}
					isEdit={props.isEdit}
					filterOptions={{
						stringify: option => `${option.coat_code} ${option.caty_title} ${option.coat_title}`
					}}
					groupBy={option => `${option.coat_type} - ${option.caty_title}`}
					getOptionLabel={option => `${option.coat_code} - ${option.coat_title}`}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* EMPLOYEES */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<NumberTextField
					name="comp_employees"
					label={t('DETAILS_COMPANIES_FIELD_EMPLOYEES')}
					value={props.model.comp_employees}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* REVENUE */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="comp_revenue"
					label={t('DETAILS_COMPANIES_FIELD_REVENUE')}
					value={props.model.comp_revenue}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* ESTABLISHMENT DATE */}
			{/* <Grid size={{ sm: 6, xs: 12 }}>
				<DateField
					name="comp_d_establishment"
					label={t('DETAILS_COMPANIES_FIELD_ESTABLISHMENT_DATE')}
					value={props.model.comp_d_establishment}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid> */}
			{/* LANGUAGE */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_lang_id"
					label={t('DETAILS_COMPANIES_FIELD_LANGUAGE')}
					systable="languages"
					value={props.model.comp_lang_id}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* PRICING GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_pric_id"
					label={t('DETAILS_COMPANIES_FIELD_PRICINGGROUP')}
					systable="pricinggroups"
					value={props.model.comp_pric_id}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* DISCOUNT GROUP */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_disc_id"
					label={t('DETAILS_COMPANIES_FIELD_DISCOUNTGROUP')}
					systable="discountgroups"
					value={props.model.comp_disc_id}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT TERMS */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_pate_id"
					label={t('DETAILS_COMPANIES_FIELD_PAYMENTTERMS')}
					systable="paymentterms"
					value={props.model.comp_pate_id}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* PAYMENT METHOD */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SearchSelectField
					name="comp_pame_id"
					label={t('DETAILS_COMPANIES_FIELD_PAYMENTMETHOD')}
					systable="paymentmethods"
					value={props.model.comp_pame_id}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
				/>
			</Grid>
			{sysSettings.orders_shipping_enabled === 'true' ? (
				<>
					{/* SHIPPING METHOD */}
					<Grid size={{ sm: 6, xs: 12 }}>
						<SearchSelectField
							name="comp_shme_id"
							label={t('DETAILS_COMPANIES_FIELD_SHIPPINGMETHOD')}
							systable="shippingmethods"
							value={props.model.comp_shme_id}
							isEdit={props.isEdit && !isErpLinked}
							sendChange={props.sendChange}
						/>
					</Grid>
					{/* SHIPPING AGENT */}
					<Grid size={{ sm: 6, xs: 12 }}>
						<SearchSelectField
							name="comp_shag_id"
							label={t('DETAILS_COMPANIES_FIELD_SHIPPINGAGENT')}
							systable="shippingagents"
							value={props.model.comp_shag_id}
							isEdit={props.isEdit && !isErpLinked}
							sendChange={props.sendChange}
						/>
					</Grid>
				</>
			) : (
				<></>
			)}
			{/* SDI */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="comp_sdi"
					label={t('DETAILS_COMPANIES_FIELD_SDI')}
					value={props.model.comp_sdi}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
			{/* CREDIT LIMIT */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<CurrencyTextField
					name="comp_creditlimit"
					label={t('DETAILS_COMPANIES_FIELD_CREDITLIMIT')}
					value={props.model.comp_creditlimit}
					isEdit={props.isEdit && !isErpLinked}
					sendChange={props.sendChange}
				/>
			</Grid>
			{/* DOMAIN */}
			<Grid size={{ sm: 6, xs: 12 }}>
				<SimpleTextField
					name="comp_domain"
					label={t('DETAILS_COMPANIES_FIELD_DOMAIN')}
					value={props.model.comp_domain}
					isEdit={props.isEdit}
					sendChange={props.sendChange}
					logProps={props.logProps}
				/>
			</Grid>
		</>
	);
}
